import React from "react";
import CEO from "../../assets/about-us/CEO.png";
import CFO from "../../assets/about-us/CFO.png";
import CTO from "../../assets/about-us/CTO.png";
import CMO from "../../assets/about-us/CMO.png";
import COO from "../../assets/about-us/COO.png";

const teamMembers = [
  {
    id: 1,
    name: "Mehtab Anwar Khalid",
    title: "Chief Executive Officer (CEO)",
    profile: CEO,
  },
  {
    id: 2,
    name: "Dr. Akhtar Hussain",
    title: "Chief Financial Officer (CFO)",
    profile: CFO,
  },
  {
    id: 3,
    name: "Muhammad Mohsin",
    title: "Chief Technology Officer (CTO)",
    profile: CTO,
  },
  {
    id: 4,
    name: "Ibrahim Anwar Khalid",
    title: "Chief Marketing Officer (CMO)",
    profile: CMO,
  },
  {
    id: 5,
    name: "Abdullah Anwar Khalid",
    title: "Chief Operating Officer (COO)",
    profile: COO,
  },
];

const CoreTeamSection = () => {
  return (
    <section className="bg-[#F5F5F5] px-4 pb-14 pt-10 sm:px-6 sm:pb-16 sm:pt-12 lg:px-8 lg:pb-20 lg:pt-16">
      <div className="mx-auto max-w-[1728px]">
        <div className="mx-auto max-w-[1056px] text-center text-black">
          <h2 className="text-[28px] font-bold leading-tight sm:text-[32px] sm:leading-[38px] lg:text-[40px] lg:leading-[47px]">
            Core Team
          </h2>
          <p className="mt-4 text-base leading-6 sm:mt-[18px] sm:text-lg sm:leading-[23px] lg:text-xl">
            A diverse group of passionate educators, technologists, and
            innovators working together to transform STEAM education through
            cutting-edge technology.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 min-[480px]:grid-cols-2 sm:mt-12 lg:grid-cols-3 lg:gap-6 xl:grid-cols-5">
          {teamMembers.map((member) => (
            <article
              key={member.id}
              className="bg-white px-4 pb-8 pt-6 text-center shadow-[0_4px_4px_0_#00000040] sm:px-6 sm:pb-10 sm:pt-8"
            >
              <div className="mx-auto flex h-36 w-36 items-center justify-center overflow-hidden rounded-full sm:h-48 sm:w-48 lg:h-[220px] lg:w-[220px]">
                <img
                  src={member.profile}
                  alt={member.name}
                  className="h-full w-full object-contain object-center"
                />
              </div>

              <h3 className="mt-4 text-base font-bold leading-snug text-black sm:mt-5 sm:text-lg sm:leading-[23px] lg:text-xl">
                {member.name}
              </h3>

              <p className="mt-2 text-sm leading-5 text-black sm:mt-3 sm:text-base sm:leading-[23px] lg:text-xl">
                {member.title}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreTeamSection;
